import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Card, Table } from 'antd'
import { connect } from 'react-redux'
import { req_list_oss_answerLog } from '../../api'

class OneQuestionRepliesModal extends Component {

    // 基礎通用參數 ////////////////////////////////////////////// 

    static propTypes = {
        item: PropTypes.object.isRequired
    }
    state = {
        items: [],
        loading: false,
    }

    UNSAFE_componentWillMount() {
        this.init_columns()
    }

    componentDidMount() {
        this.api_list_items()
    }

    // 遠端數據處理 //////////////////////////////////////////////

    api_list_items = async () => {
        const { token } = this.props.user
        const { nidQuestionlog } = this.props.item
        this.setState({ loading: true })
        const result = await req_list_oss_answerLog(nidQuestionlog, token)
        this.setState({ loading: false })
        //console.log(result)
        if (result !== null) {
            const items = result
            this.setState({ items })
        } else {
            this.setState({ items: [] })
        }
    }

    // 數據配置設定 ////////////////////////////////////////////// 

    init_columns = () => {
        this.columns = [
            {
                title: '回覆主旨',
                dataIndex: 'serviceTitle',
                width: 150,
                render: (field) => {
                    return (
                        <div>
                            <span style={{ fontSize: '1.3em' }}> {field}</span>
                        </div>
                    )
                },
            }
        ]
    }

    // 操作互動處理 //////////////////////////////////////////////

    render() {
        const { questionContent } = this.props.item
        const { loading, items } = this.state
        const title = (
            <>
                <span>{questionContent}</span>
            </>
        )
        return (
            <Card title={title}>
                <Table
                    bordered
                    scroll={{ y: 400 }}
                    loading={loading}
                    rowKey='gid'
                    dataSource={items}
                    columns={this.columns}
                    pagination={false}
                />
            </Card>
        )
    }
}

export default connect(
    state => ({ user: state.user }),
    {}
)(OneQuestionRepliesModal)